import { render, staticRenderFns } from "./PptStyleLibrary.vue?vue&type=template&id=52ad148f&scoped=true"
import script from "./PptStyleLibrary.vue?vue&type=script&lang=ts"
export * from "./PptStyleLibrary.vue?vue&type=script&lang=ts"
import style0 from "./PptStyleLibrary.vue?vue&type=style&index=0&id=52ad148f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ad148f",
  null
  
)

export default component.exports